import {User} from './user';

export class BwJiraIssue {
  id?: string;
  description: string;
  reporter: User;
  createdDate?: Date;
  updatedDate?: Date;
  updatedBy?: string;
  createdBy?: string;
  isSupport?: boolean;
}
